var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "video",
    d: "M4,3A2,2,0,0,0,2,5V19a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2ZM8.625,8.63a1.235,1.235,0,0,1,1.715-.991,28.327,28.327,0,0,1,2.916,1.48A28.331,28.331,0,0,1,16,10.9a1.234,1.234,0,0,1,0,1.98,28.3,28.3,0,0,1-2.742,1.784A28.322,28.322,0,0,1,10.34,16.15a1.234,1.234,0,0,1-1.715-.991,28.566,28.566,0,0,1-.176-3.265A28.567,28.567,0,0,1,8.625,8.63Z",
    transform: "translate(-2 -3)",
    fill: "#09244b",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.8248fe8ef8d70a3e8820966106ce204e.svg";
export { ForwardRef as ReactComponent };